<form class="title-selection-component" [formGroup]="formGroup">
  <mat-form-field [ngClass]="{readonly: readonly}">
    <mat-label>Title</mat-label>
    <mat-select [ngClass]="{readonly: readonly}" placeholder="Select Title..."
      [formControl]="formControl" (selectionChange)="onSelectionChange($event)" [disableControl]="disabled">
      @for (option of options; track option) {
        <mat-option [value]="option">{{option.name}}</mat-option>
      }
    </mat-select>
    @for (errorKey of errorKeys(formControl); track errorKey) {
      <mat-error>
        @if (formControl.touched && formControl.hasError(errorKey)) {
          {{errorMessage(formControl, errorKey)}}
        }
      </mat-error>
    }
  </mat-form-field>
</form>
